<template>
  <div id="podium-box" class="row" :style="'height: ' + boxHeight">
    <div v-if="title" class="podium-title supporting-text">{{ title }}</div>
    <div v-if="secondaryTitle" style="right:5px" class="podium-title supporting-text">{{ secondaryTitle }}</div>
    <div v-for="(d, index) in data" :key="'step_' + index" @click="clickPodium(d)" style="padding: 0px;"
      class="col-md-4 step-container m-0 p-0">
      <div v-if="displayAvatars">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" size="45px" class="grey lighten-4">
              <img v-if="!d.avatar" :src="assets('default-profile-avatar.png')" alt="avatar" />
              <ImageDisplay v-else :src="d.avatar" alt="avatar" />
            </v-avatar>
          </template>
          <span>{{ truncate(d.name, 17, true) }}</span>
        </v-tooltip>
      </div>
      <div v-if="displayScores" class="text-center">
        <span class="podium-score">{{ d.points }} {{ scoreText }}</span>
      </div>
      <div :id="getStepId(index)" class="secondary step centerBoth podium-number"
        :style="d.color ? 'background-color:' + d.color : ''">
        <div v-if="index == 0" :style="'color:white'">
          2
        </div>
        <div v-else-if="index == 1" :style="'color:white'">
          1
        </div>
        <div v-else :style="'color:white'">
          3
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'data',
    'icon',
    'title',
    'podiumAction',
    'height',
    'displayAvatars',
    'displayScores',
    'scoreText',
    'secondaryTitle'
  ],
  data() {
    return {
      boxHeight: '150px'
    }
  },
  created() {
    if (this.height)
      this.boxHeight = this.height;
  },
  methods: {
    clickPodium(p) {
      if (this.podiumAction)
        this.podiumAction(p);
    },
    getStepId(index) {
      if (index == 0)
        return 'second-step';
      else if (index == 1)
        return 'first-step';
      else if (index == 2)
        return 'third-step';
    }
  },
  components: {
  }
}
</script>

<style scoped>
#podium-box {
  margin: 0 auto;
  display: flex;
}

.podium-number {
  font-weight: bold;
  font-size: 2.5em;
}

.podium-score {
  font-size: 0.8em;
  font-weight: bold;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 6px;
  margin-bottom: 2px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.podium-title {
  position: absolute;
  float: right;
  padding-left: 10px;
  padding-top: 10px
}

.step-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.step-container>div:first-child {
  margin-top: auto;
  text-align: center;
}

.step {
  text-align: center;
}

#first-step {
  height: 50%;
}

#second-step {
  height: 35%;
}

#third-step {
  height: 30%;
}
</style>